<!-- A single image in its rotation container -->
<div [@rotate]="currentState" [ngClass]="['imageBg']">
  <img *ngIf="image && !defaultImage" class="rotation-image" [src]="'data:image/jpg;base64,'+ image.data" (error)="defaultImage=true">  
  
  <div *ngIf="image && defaultImage" class="defaultImage">
    <i class="far fa-image"></i>
  </div>
</div>
